"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryCode = exports.languageCode = exports.languageLocale = exports.languageLabel = exports.Language = void 0;
// eslint-disable-next-line no-shadow
var Language;
(function (Language) {
    Language["ENGLISH"] = "english";
    Language["DANISH"] = "danish";
    Language["NORWEIGIAN"] = "norweigian";
    Language["SWEDISH"] = "swedish";
    Language["FINNISH"] = "finnish";
    Language["GERMAN"] = "german";
    Language["SPANISH"] = "spanish";
    Language["FRENCH"] = "french";
    Language["GREEK"] = "greek";
    Language["CHINESE_SIMPLIFIED"] = "chinese-simplified";
})(Language = exports.Language || (exports.Language = {}));
exports.default = Language;
function languageLabel(language) {
    switch (language) {
        case Language.ENGLISH:
            return 'English';
        case Language.DANISH:
            return 'Danish';
        case Language.NORWEIGIAN:
            return 'Norweigian';
        case Language.SWEDISH:
            return 'Swedish';
        case Language.FINNISH:
            return 'Finnish';
        case Language.GERMAN:
            return 'German';
        case Language.SPANISH:
            return 'Spanish';
        case Language.FRENCH:
            return 'French';
        case Language.GREEK:
            return 'Greek';
        case Language.CHINESE_SIMPLIFIED:
            return 'Chinese (Simplified)';
    }
}
exports.languageLabel = languageLabel;
// See https://www.science.co.il/language/Locale-codes.php
function languageLocale(language) {
    switch (language) {
        case Language.ENGLISH:
            return 'en-gb';
        case Language.DANISH:
            return 'da';
        case Language.NORWEIGIAN:
            return 'nb-no';
        case Language.SWEDISH:
            return 'sv-se';
        case Language.FINNISH:
            return 'sv-fi';
        case Language.GERMAN:
            return 'de';
        case Language.SPANISH:
            return 'es';
        case Language.FRENCH:
            return 'fr';
        case Language.GREEK:
            return 'el';
        case Language.CHINESE_SIMPLIFIED:
            return 'zh_cn';
    }
}
exports.languageLocale = languageLocale;
// See https://www.science.co.il/language/Locale-codes.php
function languageCode(language) {
    switch (language) {
        case Language.ENGLISH:
            return 'en';
        case Language.DANISH:
            return 'da';
        case Language.NORWEIGIAN:
            return 'nb';
        case Language.SWEDISH:
            return 'sv';
        case Language.FINNISH:
            return 'fi';
        case Language.GERMAN:
            return 'de';
        case Language.SPANISH:
            return 'es';
        case Language.FRENCH:
            return 'fr';
        case Language.GREEK:
            return 'el';
        case Language.CHINESE_SIMPLIFIED:
            return 'zh';
    }
}
exports.languageCode = languageCode;
function countryCode(language) {
    switch (language) {
        case Language.ENGLISH:
            return 'GB';
        case Language.DANISH:
            return 'DK';
        case Language.NORWEIGIAN:
            return 'NO';
        case Language.SWEDISH:
            return 'SE';
        case Language.FINNISH:
            return 'FI';
        case Language.GERMAN:
            return 'DE';
        case Language.SPANISH:
            return 'ES';
        case Language.FRENCH:
            return 'FR';
        case Language.GREEK:
            return 'GR';
        case Language.CHINESE_SIMPLIFIED:
            return 'CN';
    }
}
exports.countryCode = countryCode;
